/**
 * Green Mitt Kit — hero section.
 *
 * Two jobs:
 *  1. Click-to-load facade for an external (YouTube / Vimeo) video, so the
 *     third-party player never costs a first-time visitor anything.
 *  2. The "Pick up at step N" resume control. The steps section owns the
 *     progress state; this section only listens for the `gmk:progress` event
 *     it broadcasts (and reads the last payload off `window.gmkProgressState`
 *     in case the steps section initialised first).
 */
(function () {
  function buildEmbedSrc(type, id) {
    if (type === 'youtube') {
      return 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
    }
    if (type === 'vimeo') {
      return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1';
    }
    return null;
  }

  window.GmkHero = {
    init: function (rootId) {
      var root = document.getElementById(rootId);
      if (!root || root.dataset.gmkHeroInitialized) return;
      root.dataset.gmkHeroInitialized = 'true';

      /* ---------- Video facade ---------- */
      var facade = root.querySelector('[data-gmk-video-facade]');
      if (facade) {
        facade.addEventListener('click', function () {
          var src = buildEmbedSrc(facade.dataset.gmkVideoType, facade.dataset.gmkVideoId);
          if (!src) return;

          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', src);
          iframe.setAttribute('title', facade.getAttribute('aria-label') || 'Video');
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          iframe.setAttribute('allowfullscreen', 'allowfullscreen');
          iframe.setAttribute('loading', 'lazy');

          facade.replaceWith(iframe);
          iframe.focus({ preventScroll: true });
        });
      }

      /* ---------- Resume control ---------- */
      var resumeWrap = root.querySelector('[data-gmk-resume]');
      if (!resumeWrap) return;

      var button = resumeWrap.querySelector('[data-gmk-resume-btn]');
      var label = resumeWrap.querySelector('[data-gmk-resume-label]');
      var baseLabel = label ? label.textContent.trim() : 'Pick up at step';

      function render(state) {
        // Only worth showing to someone who has started but not finished.
        var show = !!state && state.done > 0 && state.done < state.total && state.nextStep;
        resumeWrap.hidden = !show;
        if (show && label) {
          label.textContent = baseLabel + ' ' + state.nextStep;
        }
      }

      document.addEventListener('gmk:progress', function (event) {
        render(event.detail);
      });

      // The steps section may have broadcast before this script ran.
      render(window.gmkProgressState);

      if (button) {
        button.addEventListener('click', function () {
          document.dispatchEvent(new CustomEvent('gmk:resume'));
        });
      }
    }
  };
})();
